export const BASE_URL = "/api/v1"

//Auth Module
export const GET_USER = "/api/v1/user"
export const PUT_UPDATE_USER = "/api/v1/user"

export const GET_ORGANISATIONS = "/api/v1/organisations"
export const GET_ORGANISATION_ROLES = "/api/v1/organisation-roles"
export const POST_RESET_PASSWORD = "/dbconnections/change_password"
